import { Constants, PathUtils } from '@adobe/aem-spa-page-model-manager';

/**
 * Recursively checks if the page model contains a component of the specified type.
 * @param {object} obj - The page model object to search.
 * @param {string} componentType - The component resource type to search for.
 * @returns {boolean} True if the component is found.
 */
export function hasComponent(obj, componentType) {
    if (obj && obj[Constants.TYPE_PROP] === componentType) {
        return true;
    }
    const childrenProps = [Constants.CHILDREN_PROP, ':items'];
    for (const prop of childrenProps) {
        if (obj && obj[prop]) {
            for (const child of Object.values(obj[prop])) {
                if (hasComponent(child, componentType)) return true;
            }
        }
    }
    return false;
}
/**
 * Checks if the default page model contains a component of the specified type.
 * @param {string} componentType - The component resource type to search for.
 * @returns {boolean} True if the component is found.
 */
export function hasDefaultComponent(component) {
    const pageModelJson = JSON.parse(
        PathUtils.getMetaPropertyValue('cq:pageModel'),
    );
    if (
        'componentsResourceTypes' in pageModelJson &&
        pageModelJson.componentsResourceTypes.lastIndexOf(component) >= -1
    ) {
        return true;
    }
    return hasComponent(pageModelJson, component);
}

/**
 * Checks if the page model contains the Terms and Conditions component.
 * @param {object} obj - The page model object to search.
 * @returns {boolean} True if the Terms and Conditions component is found.
 */
export function hasTermsComponent(obj) {
    return hasComponent(
        obj,
        'cob-corp-acquisition/components/creditonebank/terms-and-conditions',
    );
}
